import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Project } from '../models/Project';
import { API_SETTINGS } from './API_SETTINGS';
import { XapiProjectLaunch } from '../models/XapiProjectLaunch';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrl = API_SETTINGS.API_URL + 'Project';

@Injectable({
  providedIn: 'root'
})
export class ApiProjectService {
   projects: Project[] = [];
  
  constructor(private http: HttpClient) { }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getProjectsWithCustomerId(customerId: number): Observable<Project[]> {
    const url = apiUrl + '/GetProjectsWithCustomerId';
    return this.http.post<Project[]>(url, customerId, httpOptions).pipe(
      catchError(this.handleError<Project[]>('GetProjectsWithCustomerId'))
    );
  }

  
  getProjectsLaunchUsage(projectIds): Observable<XapiProjectLaunch[]>{
    const url = apiUrl + '/getProjectsLaunchUsageByProjectIds';
    return this.http.post<XapiProjectLaunch[]>(url, projectIds, httpOptions).pipe(
      catchError(this.handleError<XapiProjectLaunch[]>('getProjectsLaunchUsageByCustomerId'))
    );
  }

  async getProject(id: number) {
    const url = `${apiUrl}/GetProject/${id}`;
    const data = await this.http.get<Project>(url).toPromise();
    var projectJSON = JSON.stringify(data);
    return JSON.parse(projectJSON);
  }

  addProject (project: Project): Observable<Project> {  
    const url = apiUrl + '/PostProject';
    return this.http.post<Project>(url, project, httpOptions).pipe(
      catchError(this.handleError<Project>('addProject'))
    )
  }
  
  updateProject (id: number, Project: any): Observable<Project>{
    const url = `${apiUrl}/PutProject/${id}`;
    return this.http.put(url, Project, httpOptions).pipe(
      tap((ProjectRes: Project) => true ), //console.log()),
      catchError(this.handleError<Project>('updateProject'))
    )
  }
  
  deleteProject (id: number): Observable<Project> {
    const url = `${apiUrl}/DeleteProject/${id}`;
    return this.http.delete<Project>(url, httpOptions).pipe(
      tap((ProjectRes: Project) => true ), //console.log()),
      catchError(this.handleError<Project>('deleteProject'))
    )
  }
  

}
